import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class Logger {
  debug(message: string, ...optionalParams: unknown[]): void {
    if (!environment.production) {
      console.debug(message, ...optionalParams);
    }
  }

  log(message: string, ...optionalParams: unknown[]): void {
    if (!environment.production) {
      console.log(message, ...optionalParams);
    }
  }

  warn(message: string, ...optionalParams: unknown[]): void {
    console.warn(message, ...optionalParams);
  }

  error(message: string, ...optionalParams: unknown[]): void {
    console.error(message, ...optionalParams);
  }
}
